// removed by extract-text-webpack-plugin
module.exports = {"m-adjustment__label":"jOupnDhGuy4ER5VCcJ_XL","m-total__label":"_1YAd3DG6xUjHEBSNmEMFvW","m-adjustment__amount":"_1RKf53UnFKrcvyogPygnWy","m-total__amount":"ObZCIE2PyWMWzlcMP1HfG","m-adjustment__information":"_11_ONbOWvPJzgXmoqFUm0i","m-total__information":"_2LcJoFZRQ-SgEBArxqyVOm","painters-vat__label":"_3X-oSBQy39rp5h0hecLOVC","m-subtotals__information":"_3h_ckH14y9rOixNm58T-2Z","m-orderSubtotal":"_1ittmpUrRchA_yrW3Xtzqw"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/Adjustment/style.scss
// module id = 440
// module chunks = 0